// theme overrides
import { JSONEditor } from '@json-editor/json-editor'
import DOMPurify from 'dompurify'
import { marked } from 'marked'
DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank')
    // DOMPurify strips target="_blank" on anchor elements unless rel="noopener noreferrer" is also present — this is a security measure to prevent reverse tabnapping attacks.
    node.setAttribute('rel', 'noopener noreferrer')
  }
})
const markdown = (value = '') => value ? DOMPurify.sanitize(marked.parse(value)) : ''

const Bootstrap4Theme = JSONEditor.defaults.themes.bootstrap4

class LXPTheme extends Bootstrap4Theme {
  constructor (jsoneditor) {
    super(jsoneditor)

    Object.assign(this.options, {
      object_background: 'bg-white',
      table_border: true,
      table_zebrastyle: true
    })
  }

  getHeader (text, pathDepth) {
    const el = super.getHeader(text, pathDepth)
    el.style.display = ''
    return el
  }

  getButton (text, icon, title, args = [], color = 'btn-outline-secondary') {
    const el = JSONEditor.AbstractTheme.prototype.getButton.apply(this, arguments)
    el.classList.add('btn', color)
    return el
  }

  getIndentedPanel () {
    const el = document.createElement('div')
    el.classList.add('card', 'card-body')

    if (this.options.object_background) {
      el.classList.add(this.options.object_background)
    }

    if (this.options.object_text) {
      el.classList.add(this.options.object_text)
    }

    return el
  }

  getDescription (text) {
    const el = document.createElement('small')
    const processedText = text.replace(/\n/g, '  \n')
    el.innerHTML = markdown(processedText)
    el.classList.add('form-text')
    el.classList.add('description-text')
    return el
  }

  getCheckboxDescription (text) {
    return this.getDescription(text)
  }

  getFormInputDescription (text) {
    const el = document.createElement('small')
    el.classList.add('form-text')
    const tempContainer = document.createElement('div')
    const processedText = text.replace(/\n/g, '  \n')
    tempContainer.innerHTML = markdown(processedText)
    el.innerHTML = tempContainer.firstChild?.nodeName === 'P'
      ? tempContainer.firstChild.innerHTML
      : tempContainer.innerHTML
    el.classList.add('description-text')

    return el
  }

  // getButton (text, icon, title, color = 'btn-secondary') {
  //   const el = super.getButton(text, icon, title)
  //   el.classList.add('btn', 'btn-secondary', 'btn-sm')
  //   return el
  // }
  
  // getButton (text, icon, title, color = 'btn-secondary') {
  //   if (typeof icon === 'string') {
  //     const iconClass = `icon-${icon}`
  //     icon = document.createElement('i')
  //     icon.classList.add('mr-2')
  //     // icon.classList.add('btn-icon')
  //     icon.classList.add(iconClass)
  //   }
  //   var el = super.getButton(text, icon, title)
  //   el.classList.remove('btn-secondary')
  //   el.classList.add('btn')
  //   el.classList.add(color)
  //   return el
  // }
  
  // getCloseButton () {
  //   var el = document.createElement('button')
  //   el.type = 'button'
  //   el.innerHTML = '&times;'
  //   el.classList.add('close')
  //   el.classList.add('position-absolute')
  //   el.classList.add('font-size-lg')
  //   el.style.top = '0.25rem'
  //   el.style.right = '0.5rem'
  //   return el
  // }
  
  // getTable () {
  //   var el = document.createElement('table')
  //   el.classList.add('table-bordered')
  //   el.classList.add('table-sm')
  //   el.style.width = 'auto'
  //   el.style.maxWidth = 'none'
  //   return el
  // }
  
  // getHeaderButtonHolder () {
  //   var el = this.getButtonHolder()
  //   // el.classList.add('ml-1')
  //   return el
  // }
  
  // addInputError (input, text) {
  //   // DO NOTHING
  // }
  
  // updateProgressBarUnknown (progressBar) {
  //   if (!progressBar) return

  //   var bar = progressBar.firstChild
  //   progressBar.classList.add('progress')
  //   progressBar.classList.add('progress-striped')
  //   progressBar.classList.add('active')
  //   bar.removeAttribute('aria-valuenow')
  //   bar.style.width = '100%'
  //   bar.innerHTML = ''
  // }
  
  // getSwitcher (options) {
  //   var switcher = this.getSelectInput(options)

  //   switcher.style.maxWidth = '60%'
  //   switcher.style.marginBottom = '1rem'
  //   return switcher
  // }
}

export default LXPTheme
